export default __webpack_public_path__ + "static/media/wiz.e186d003.svg";